module.exports = __webpack_public_path__ + "media/images/athletes/1513-0e0b3068c20d34253508da10a0e885b9.png";